import owd from 'owd/owd';

export default class BrowserCheck extends owd.Module {
    constructor(app) {
        super(app);

        this.bind();
    }

    bind() {
        this.app.dom.$window.on('domready', (e) => {
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
                $('html').addClass('is-ie');
            }

            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    			$('html').addClass('is-safari');
    		}
        })
    }
}
